var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useReducer, } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { getPipelineData } from "../api/api";
import { PIPELINE_SET_LOADING, PIPELINE_SET_PIPELINE, SET_FULL_PAGE_LOADING, } from "../constants";
import { activePipelineReducer } from "../reducers/active-pipeline-reducer";
import { LoadingContext } from "./LoadingContextProvider";
const initialState = {
    loading: false,
    activePipeline: null,
};
const ActivePipelineContext = createContext({
    state: initialState,
    dispatch: () => { },
    fetchAndSetPipelineData: () => { },
});
const ActivePipelineContextProvider = ({ children, }) => {
    const [state, dispatch] = useReducer(activePipelineReducer, initialState);
    const { loadingDispatch } = useContext(LoadingContext);
    useEffect(() => {
        const initialActivePipelineId = window.wpqt.initialActivePipelineId;
        if (initialActivePipelineId) {
            fetchAndSetPipelineData(initialActivePipelineId, true);
        }
    }, []);
    const setLoadingState = (isLoading, fullPageLoading) => {
        if (fullPageLoading) {
            loadingDispatch({
                type: SET_FULL_PAGE_LOADING,
                payload: isLoading,
            });
        }
        else {
            dispatch({ type: PIPELINE_SET_LOADING, payload: isLoading });
        }
    };
    const fetchAndSetPipelineData = (pipelineId_1, ...args_1) => __awaiter(void 0, [pipelineId_1, ...args_1], void 0, function* (pipelineId, fullPageLoading = false) {
        try {
            setLoadingState(true, fullPageLoading);
            const { data: { pipeline }, } = yield getPipelineData(pipelineId);
            dispatch({ type: PIPELINE_SET_PIPELINE, payload: pipeline });
        }
        catch (e) {
            console.error(e);
            toast.error(__("Unable to load the board. Please try again later.", "quicktasker"));
        }
        finally {
            setLoadingState(false, fullPageLoading);
        }
    });
    return (_jsx(ActivePipelineContext.Provider, { value: { state, dispatch, fetchAndSetPipelineData }, children: children }));
};
export { ActivePipelineContext, ActivePipelineContextProvider, };
